// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"20dafbf5","702":"076df395"}[chunkId] + ".chunk.js";
};